import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1927dd7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "t" }
const _hoisted_2 = { class: "t_cn" }
const _hoisted_3 = { class: "t_en" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"title-center\" data-v-1927dd7e></div><div class=\"C-line\" data-v-1927dd7e><div class=\"point\" data-v-1927dd7e></div><div class=\"line\" data-v-1927dd7e></div><div class=\"point\" data-v-1927dd7e></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.cn), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.en), 1)
    ]),
    _hoisted_4
  ]))
}